import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-[#17304F] text-white py-24 px-6" data-id="element-263">
      <div className="max-w-3xl mx-auto text-center" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-slate-800/50 border border-slate-700 p-8 md:p-12 rounded-2xl relative" data-id="element-265">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-amber-600 text-white p-3 rounded-full shadow-lg" data-id="element-266">
            <Clock size={28} data-id="element-267" />
          </div>

          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-offwhite mb-8 mt-4" data-id="element-268">
            Lo que cambia en 7 días
          </h2>

          <div className="text-lg md:text-xl text-slate-300 leading-relaxed space-y-6 font-medium" data-id="element-269">
            <p data-id="element-270">
              👉 Al aplicar estos protocolos, lo primero que vas a notar es que{' '}
              <strong className="text-white border-b-2 border-green-500/50" data-id="element-271">
                el silencio vuelve a tu casa
              </strong>
              .
            </p>
            <p data-id="element-272">
              Tu ex, al no encontrar la reacción que lo alimenta,{' '}
              <em data-id="element-273">empieza a buscar otra vía o simplemente se rinde</em>.
            </p>
            <p className="pt-4" data-id="element-274">
              Pero lo más importante sucede en tu interior:{' '}
              <strong className="text-amber-400 text-2xl block mt-2" data-id="element-275">
                la taquicardia desaparece.
              </strong>
            </p>
            <p data-id="element-276">
              Volvés a ser dueño de tu tiempo y tus hijos recuperan a un
              padre/madre que está <strong data-id="element-277">realmente ahí</strong>, con la cabeza
              en el presente.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}